export default __webpack_public_path__ + "static/media/chat_app.c717ccfd.jpg";